<template>
  <div class="coi-page-header" :style="headerStyle">
    <div class="header-left">
      <h1>
        <i v-if="icon" :class="icon"></i>
        {{ title }}
      </h1>
      <p v-if="subtitle" class="header-subtitle">{{ subtitle }}</p>
    </div>
    <div v-if="$slots.actions" class="header-actions">
      <slot name="actions" />
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue'
import whitelabelBranding from '@/services/whitelabelBrandingService'

defineProps({
  title: { type: String, required: true },
  subtitle: { type: String, default: '' },
  icon: { type: String, default: '' },
})

const primaryColor = ref('#1E40AF')

onMounted(async () => {
  try {
    await whitelabelBranding.initialize()
    primaryColor.value = whitelabelBranding.getColor('primary') || primaryColor.value
  } catch {
    // default primary
  }
})

const headerStyle = computed(() => ({
  '--coi-primary': primaryColor.value,
}))
</script>

<style scoped>
.coi-page-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 1rem;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid color-mix(in srgb, var(--coi-primary, #1E40AF) 15%, transparent);
}

.header-left h1 {
  margin: 0 0 0.35rem;
  font-size: 1.75rem;
  color: var(--coi-primary, #1E40AF);
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.header-subtitle {
  margin: 0;
  color: #64748b;
  font-size: 0.95rem;
}

.header-actions {
  display: flex;
  gap: 0.75rem;
  flex-shrink: 0;
}
</style>
